/**
 * Live-formats a UK postcode as the user types: uppercases it and inserts
 * the space before the 3-character inward code (e.g. "sw1a1aa" -> "SW1A 1AA").
 * Caps at 7 stripped characters — the longest a real UK postcode can be
 * (4-character outward code + 3-character inward code) — so pasted text or
 * typos don't keep growing past a valid shape.
 */
export const formatUkPostcode = (value) => {
  const stripped = value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 7);
  if (stripped.length <= 3) return stripped;
  return `${stripped.slice(0, -3)} ${stripped.slice(-3)}`;
};
